module.exports = __webpack_public_path__ + "static/CLAN-1a500be1a2a271e88ed3d4b8cfa90ced.mp4";